export default __webpack_public_path__ + "static/loomis_pay_standard.png";